import { useEffect } from 'react'
import { ModalHeader } from './ModalHeader'
import { ModalFormWrapper } from './ModalFormWrapper'

const LedDeviceSettingModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-550px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body'>
              <ModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export { LedDeviceSettingModal }
